import React from 'react';
import { Badge, Button, Spinner, Table } from 'react-bootstrap';

const money = cents => new Intl.NumberFormat('pt-BR', {
  style: 'currency', currency: 'BRL',
}).format(Number(cents || 0) / 100);

const dateTime = value => value
  ? new Date(value).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' })
  : '—';

const ACTIONS = {
  contracted: ['Contratado', 'success'],
  increased: ['Aumentado', 'primary'],
  reduced: ['Reduzido', 'warning'],
  canceled: ['Cancelado', 'secondary'],
  imported: ['Contrato existente', 'info'],
  payment_pending: ['Pagamento pendente', 'warning'],
  payment_received: ['Pagamento recebido', 'info'],
  payment_failed: ['Pagamento falhou', 'danger'],
};

const ConnectionAddonsHistory = ({ history, loading, retrying, onPayWithAnotherCard, onCancelCheckout }) => (
  <section style={{ padding: '20px', border: '1px solid #e5e7eb', borderRadius: '16px', background: '#fff' }}>
    <div className='mb-3'>
      <h3 style={{ fontSize: '16px', fontWeight: 800, margin: 0 }}>Histórico de conexões adicionais</h3>
      <small className='text-muted'>Contratações, alterações de quantidade e cancelamentos da assinatura.</small>
    </div>

    {loading ? (
      <div className='text-center py-4'><Spinner animation='border' size='sm' /></div>
    ) : history.length === 0 ? (
      <div className='text-muted text-center py-4'>Nenhuma alteração de conexão adicional registrada.</div>
    ) : (
      <Table responsive hover className='align-middle mb-0'>
        <thead>
          <tr><th>Data</th><th>Adicional</th><th>Ação</th><th>Quantidade</th><th>Valor mensal</th><th>Observação</th><th></th></tr>
        </thead>
        <tbody>
          {history.map(event => {
            const [label, variant] = ACTIONS[event.action] || [event.action, 'secondary'];
            return (
              <tr key={event.id}>
                <td>{dateTime(event.created_at)}</td>
                <td>{event.addon?.name || 'Conexão adicional'}</td>
                <td><Badge bg={variant}>{label}</Badge></td>
                <td>{event.previous_quantity} → {event.new_quantity}</td>
                <td>{event.prorated_amount != null
                  ? <><span className='text-muted'>Proporcional: </span><strong>{money(event.prorated_amount)}</strong></>
                  : <>{money(event.previous_monthly_amount)} → <strong>{money(event.new_monthly_amount)}</strong></>}</td>
                <td className='text-muted small'>{event.description || '—'}</td>
                <td><div className='d-flex flex-wrap gap-2'>
                  {event.can_retry_with_another_card && <Button size='sm' variant='outline-primary' disabled={retrying === event.purchase_id} onClick={() => onPayWithAnotherCard(event)}>{retrying === event.purchase_id ? <Spinner size='sm' animation='border' /> : 'Pagar com outro cartão'}</Button>}
                  {event.can_resume_checkout && <Button size='sm' variant='primary' onClick={() => onPayWithAnotherCard(event)}>Continuar pagamento</Button>}
                  {event.can_cancel_checkout && <Button size='sm' variant='outline-danger' disabled={retrying === event.purchase_id} onClick={() => onCancelCheckout(event)}>Cancelar tentativa</Button>}
                </div></td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    )}
  </section>
);

export default ConnectionAddonsHistory;
